import { render } from "./DButton.vue?vue&type=template&id=3b75e48e"
import script from "./DButton.vue?vue&type=script&lang=ts"
export * from "./DButton.vue?vue&type=script&lang=ts"
script.render = render

export default script